import { Edit05 } from '@aktiia/design-system';
import { useTranslation } from 'react-i18next';

import { ModalName } from '../../../enums';
import { useAccount } from '../../../features/account';
import { useOpenModal } from '../../../features/modals';
import { getUserName, parseUserRoles } from '../../../utils';
import { Button, Card } from '../../common';
import { InlineFormField } from '../inline-form-field';

export const Profile = () => {
  const { t } = useTranslation();
  const { account } = useAccount();
  const openEditUserModal = useOpenModal(ModalName.EDIT_ACCOUNT);
  const openContactSupportModal = useOpenModal(ModalName.CONTACT_SUPPORT);

  const onEdit = () => {
    openEditUserModal({ account });
  };

  return (
    <Card className="max-w-[640px]">
      <div className="flex items-center justify-between">
        <h3 className="typography-heading-large text-text-primary">
          {t('profile.title', { name: getUserName(account) })}
        </h3>
        <div>
          <Edit05 className="cursor-pointer" onClick={onEdit} />
        </div>
      </div>

      <p className="typography-paragraph-3 text-text-secondary mt-2 mb-6">{t('profile.subtitle')}</p>

      <InlineFormField className="py-4" title={t('profile.field.email')} value={account?.username} />
      <InlineFormField className="py-4" title={t('profile.field.telephone')} value={account?.telephone} />
      <InlineFormField className="py-4" title={t('profile.field.password')} value={account && '••••••••'} />
      <InlineFormField className="py-4" title={t('profile.field.role')} value={parseUserRoles(account)} />

      <div className="mt-6">
        <Button text={t('profile.button.support')} size="sm" onClick={() => openContactSupportModal()} />
      </div>
    </Card>
  );
};
